import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import OfficeCleaningPage from '../pages/services/page';
import AboutPage from '../pages/about/page';
import MetairiePage from '../pages/location/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services/office-cleaning', element: <OfficeCleaningPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/locations/metairie-la', element: <MetairiePage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
